// Authentication
export const LOG_IN = 'LOG_IN';

// Negotiation Lots
export const SELECT_LOT_FOR_EDIT = 'SELECT_LOT_FOR_EDIT';
export const LOAD_SUB_LOTS = 'LOAD_SUB_LOTS';
export const SAVE_NEGOTIATION_LOT = 'SAVE_NEGOTIATION_LOT';
export const UPDATE_LOT_STORE = 'UPDATE_LOT_STORE';
export const ERASE_LOT = 'ERASE_LOT';

// Negotiation Sub Lots
export const ADD_NEW_EMPTY_SUB_LOT = 'ADD_NEW_EMPTY_SUB_LOT';
export const GET_SUB_LOT_BY_ID = 'GET_SUB_LOT_BY_ID';
export const FILL_SUB_LOT_DATA = 'FILL_SUB_LOT_DATA';
export const UPDATE_SUB_LOT_STORE = 'UPDATE_SUB_LOT_STORE';
export const PUSH_NEW_EMPTY_SUBLOT = 'PUSH_NEW_EMPTY_SUBLOT';
export const ERASE_SUB_LOTS = 'ERASE_SUB_LOTS';
export const ERASE_SUB_LOT_BY_ID = 'ERASE_SUB_LOT_BY_ID';
export const REFRESH_SUB_LOT_IDS = 'REFRESH_SUB_LOT_IDS';

// Optionals
export const GET_OPTIONALS_BY_SUB_LOT = 'GET_OPTIONALS_BY_SUB_LOT';
export const ADD_OPTIONALS_BY_SUB_LOT = 'ADD_OPTIONALS_BY_SUB_LOT';
export const PUSH_OPTIONALS_BY_SUB_LOT = 'PUSH_OPTIONALS_BY_SUB_LOT';
export const REMOVE_OPTIONALS_BY_SUB_LOT = 'REMOVE_OPTIONALS_BY_SUB_LOT';
export const LOAD_OPTIONALS_STORE_BY_LOT = 'LOAD_OPTIONALS_STORE_BY_LOT';
export const ERASE_OPTIONALS = 'ERASE_OPTIONALS';
export const REFRESH_OPTIONALS_SUB_LOT_IDS = 'REFRESH_OPTIONALS_SUB_LOT_IDS';
export const ERASE_OPTIONALS_BY_SUB_LOT = 'ERASE_OPTIONALS_BY_SUB_LOT';
export const LOG_OFF = 'LOG_OFF';

//Used Rental Lots
export const SAVE_LOT = 'SAVE_LOT';
export const GET_RU_SUB_LOT_BY_ID = 'GET_RU_SUB_LOT_BY_ID';

export const ERASE_RU_SUB_LOTS = 'ERASE_RU_SUB_LOTS';
export const ERASE_RU_SUB_LOT_BY_ID = 'ERASE_RU_SUB_LOT_BY_ID';
export const LOAD_RU_SUB_LOTS = 'LOAD_RU_SUB_LOTS';
export const UPDATE_RU_SUB_LOT_STORE = 'UPDATE_RU_SUB_LOT_STORE';
export const PUSH_RU_EMPTY_SUBLOT = 'PUSH_RU_EMPTY_SUBLOT';
export const REFRESH_RU_SUB_LOT_IDS = 'REFRESH_RU_SUB_LOT_IDS';


// WEBPACK FOOTER //
// ./src/store/actions/types.js